<template>
    <div class="form-edit-page">
        <div class="page-header">
            <div>
                <h1>Inspeção de Supervisão</h1>
                <p>Relatório de Supervisão do Serviço de Inspeção Municipal</p>
            </div>

            <div class="header-actions">
                <button class="btn btn-light" @click="expandirTodos">Expandir tudo</button>
                <button class="btn btn-light" @click="recolherTodos">Recolher tudo</button>
                <button class="btn btn-primary" @click="finalizarRelatorio">Finalizar relatório</button>
            </div>
        </div>

        <!-- CABEÇALHO -->
        <section class="card-section">
            <div class="section-title">Parte 1 - Identificação</div>

            <div class="form-grid cols-3">
                <div class="form-item">
                    <label>Número do Relatório</label>
                    <input v-model="form.numeroRelatorio" type="text" />
                </div>

                <div class="form-item">
                    <label>Data</label>
                    <input v-model="form.dataRelatorio" type="date" />
                </div>

                <div class="form-item">
                    <label>Auditores</label>
                    <input v-model="form.auditoresResumo" type="text" placeholder="Resumo dos auditores" />
                </div>
            </div>

            <div class="subsection-title">1.1 Serviço de Inspeção Municipal</div>

            <div class="form-grid cols-3">
                <div class="form-item">
                    <label>Nome do Órgão</label>
                    <input v-model="form.orgao.nome" type="text" />
                </div>

                <div class="form-item">
                    <label>Responsável</label>
                    <input v-model="form.orgao.responsavel" type="text" />
                </div>

                <div class="form-item">
                    <label>Endereço</label>
                    <input v-model="form.orgao.endereco" type="text" />
                </div>

                <div class="form-item">
                    <label>Cidade / Sede</label>
                    <input v-model="form.orgao.cidade" type="text" />
                </div>

                <div class="form-item">
                    <label>UF</label>
                    <input v-model="form.orgao.uf" type="text" maxlength="2" />
                </div>

                <div class="form-item">
                    <label>Fone</label>
                    <input v-model="form.orgao.fone" type="text" />
                </div>

                <div class="form-item col-span-2">
                    <label>E-mail</label>
                    <input v-model="form.orgao.email" type="text" />
                </div>
            </div>

            <div class="subsection-title">1.2 Equipe de Inspeção</div>

            <div class="form-grid cols-4">
                <div class="form-item col-span-2">
                    <label>Responsável pelo Serviço de Inspeção / Coordenador</label>
                    <input v-model="form.equipe.coordenador" type="text" />
                </div>

                <div class="form-item">
                    <label>Nº Veterinários / Fiscais</label>
                    <input v-model.number="form.equipe.qtdVeterinarios" type="number" min="0" />
                </div>

                <div class="form-item">
                    <label>Nº Auxiliares</label>
                    <input v-model.number="form.equipe.qtdAuxiliares" type="number" min="0" />
                </div>

                <div class="form-item col-span-2">
                    <label>Nº Auxiliares Administrativos / Função</label>
                    <input v-model="form.equipe.auxiliaresAdministrativos" type="text" />
                </div>

                <div class="form-item">
                    <label>Carteira de saúde dos funcionários</label>
                    <select v-model="form.equipe.carteiraSaude">
                        <option value="">Selecione</option>
                        <option value="C">Conforme</option>
                        <option value="NC">Não Conforme</option>
                    </select>
                </div>

                <div class="form-item">
                    <label>Total Parte 1</label>
                    <input :value="totaisParte1" type="text" disabled />
                </div>
            </div>

            <div class="form-item">
                <label>Observações da Identificação / Equipe</label>
                <textarea v-model="form.equipe.observacoes" rows="4"></textarea>
            </div>
        </section>

        <!-- ITENS -->
        <section
            v-for="(secao, secaoIndex) in secoes"
            :key="secao.id"
            class="card-section"
        >
            <div class="section-header-clickable" @click="secao.aberta = !secao.aberta">
                <div>
                    <div class="section-title">{{ secao.titulo }}</div>
                    <div class="section-subtitle">
                        {{ secao.itens.length }} item(ns) |
                        C: {{ contarStatus(secao, 'C') }} |
                        NC: {{ contarStatus(secao, 'NC') }} |
                        NA: {{ contarStatus(secao, 'NA') }}
                    </div>
                </div>

                <div class="section-toggle">
                    {{ secao.aberta ? '−' : '+' }}
                </div>
            </div>

            <div v-show="secao.aberta">
                <div v-if="secao.camposExtras" class="form-grid cols-5">
                    <div class="form-item">
                        <label>Carne</label>
                        <input v-model.number="secao.camposExtras.carne" type="number" min="0" />
                    </div>
                    <div class="form-item">
                        <label>Leite</label>
                        <input v-model.number="secao.camposExtras.leite" type="number" min="0" />
                    </div>
                    <div class="form-item">
                        <label>Mel</label>
                        <input v-model.number="secao.camposExtras.mel" type="number" min="0" />
                    </div>
                    <div class="form-item">
                        <label>Ovos</label>
                        <input v-model.number="secao.camposExtras.ovos" type="number" min="0" />
                    </div>
                    <div class="form-item">
                        <label>Pescados</label>
                        <input v-model.number="secao.camposExtras.pescados" type="number" min="0" />
                    </div>
                </div>

                <div class="checklist-table">
                    <div class="checklist-head">
                        <div>Item avaliado</div>
                        <div class="status-col">C</div>
                        <div class="status-col">NC</div>
                        <div class="status-col">NA</div>
                    </div>

                    <div
                        v-for="(item, itemIndex) in secao.itens"
                        :key="item.id"
                        class="checklist-row"
                    >
                        <div class="item-desc">
                            <span class="item-code">{{ item.codigo }}</span>
                            <span>{{ item.descricao }}</span>
                        </div>

                        <div class="status-col">
                            <input
                                :name="`status-${secaoIndex}-${itemIndex}`"
                                type="radio"
                                value="C"
                                v-model="item.status"
                            />
                        </div>

                        <div class="status-col">
                            <input
                                :name="`status-${secaoIndex}-${itemIndex}`"
                                type="radio"
                                value="NC"
                                v-model="item.status"
                            />
                        </div>

                        <div class="status-col">
                            <input
                                :name="`status-${secaoIndex}-${itemIndex}`"
                                type="radio"
                                value="NA"
                                v-model="item.status"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-item mt-12">
                    <label>Observações da seção</label>
                    <textarea v-model="secao.observacoes" rows="4"></textarea>
                </div>
            </div>
        </section>

        <!-- FINALIZAÇÃO -->
        <section class="card-section">
            <div class="section-title">Finalização / Relatório</div>

            <div class="summary-grid">
                <div class="summary-card">
                    <div class="summary-label">Total de Itens</div>
                    <div class="summary-value">{{ resumo.totalItens }}</div>
                </div>
                <div class="summary-card">
                    <div class="summary-label">Conformes</div>
                    <div class="summary-value">{{ resumo.totalC }}</div>
                </div>
                <div class="summary-card">
                    <div class="summary-label">Não Conformes</div>
                    <div class="summary-value">{{ resumo.totalNC }}</div>
                </div>
                <div class="summary-card">
                    <div class="summary-label">NA</div>
                    <div class="summary-value">{{ resumo.totalNA }}</div>
                </div>
                <div class="summary-card destaque">
                    <div class="summary-label">% Atendimento</div>
                    <div class="summary-value">{{ resumo.percentualAtendimento }}%</div>
                </div>
            </div>

            <div class="form-item">
                <label>Parte 10 - Comentários / Observações / Recomendações</label>
                <textarea v-model="form.finalizacao.comentarios" rows="5"></textarea>
            </div>

            <div class="form-item">
                <label>Parte 11 - Conclusões</label>
                <textarea v-model="form.finalizacao.conclusoes" rows="5"></textarea>
            </div>

            <div class="subsection-title">Parte 12 - Auditores</div>

            <div class="inline-actions">
                <button class="btn btn-light" @click="adicionarAuditor">+ Auditor</button>
            </div>

            <div class="table-simple">
                <div class="table-head">
                    <div>Nome</div>
                    <div>Cargo / Função</div>
                    <div class="col-acoes">Ações</div>
                </div>

                <div
                    v-for="(auditor, index) in form.finalizacao.auditores"
                    :key="`auditor-${index}`"
                    class="table-row"
                >
                    <div>
                        <input v-model="auditor.nome" type="text" />
                    </div>
                    <div>
                        <input v-model="auditor.cargo" type="text" />
                    </div>
                    <div class="col-acoes">
                        <button class="btn-icon" @click="removerAuditor(index)">🗑</button>
                    </div>
                </div>
            </div>

            <div class="subsection-title">Parte 13 - Autoridades e Técnicos Presentes</div>

            <div class="inline-actions">
                <button class="btn btn-light" @click="adicionarPresente">+ Presente</button>
            </div>

            <div class="table-simple">
                <div class="table-head">
                    <div>Nome</div>
                    <div>Cargo / Função</div>
                    <div class="col-acoes">Ações</div>
                </div>

                <div
                    v-for="(presente, index) in form.finalizacao.presentes"
                    :key="`presente-${index}`"
                    class="table-row"
                >
                    <div>
                        <input v-model="presente.nome" type="text" />
                    </div>
                    <div>
                        <input v-model="presente.cargo" type="text" />
                    </div>
                    <div class="col-acoes">
                        <button class="btn-icon" @click="removerPresente(index)">🗑</button>
                    </div>
                </div>
            </div>
        </section>

        <section class="card-section">
            <div class="section-title">Pré-visualização dos dados para relatório</div>

            <pre class="json-preview">{{ payloadRelatorio }}</pre>
        </section>
    </div>
</template>

<script>
import { computed, reactive } from 'vue';

export default {
    name: 'SupervisaoSimForm',
    setup() {
        const form = reactive({
            numeroRelatorio: 'SIM 01/ARARANGUA/2026',
            dataRelatorio: new Date().toISOString().slice(0, 10),
            auditoresResumo: 'Equipe Consórcio / Coordenação',
            orgao: {
                nome: 'Serviço de Inspeção Municipal de Araranguá',
                responsavel: 'Dr. João da Silva',
                endereco: 'Rua Exemplo, 100',
                cidade: 'Araranguá',
                uf: 'SC',
                fone: '(48) 99999-9999',
                email: 'sim@municipio.sc.gov.br',
            },
            equipe: {
                coordenador: 'Dra. Maria Coordenadora',
                qtdVeterinarios: 2,
                qtdAuxiliares: 1,
                auxiliaresAdministrativos: '1 auxiliar administrativo',
                carteiraSaude: 'C',
                observacoes: '',
            },
            finalizacao: {
                comentarios: '',
                conclusoes: '',
                auditores: [
                    { nome: 'Auditor 1', cargo: 'Médico Veterinário' },
                    { nome: 'Auditor 2', cargo: 'Coordenador de Supervisão' },
                ],
                presentes: [
                    { nome: 'Responsável SIM', cargo: 'Coordenador do SIM' },
                ],
            },
        });

        const criarItem = (codigo, descricao, status = '') => ({
            id: `${codigo}-${descricao}`,
            codigo,
            descricao,
            status,
        });

        const secoes = reactive([
            {
                id: '2',
                titulo: 'Parte 2 - Aspectos Gerais',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('2.1.a', 'Controle de entrada, saída de documentos oficiais e localização do arquivo'),
                    criarItem('2.1.b', 'Controle de documentos internos – pastas de arquivos conforme Manual do S.I.M.'),
                    criarItem('2.2.a', 'Lei que institui o Serviço de Inspeção – cópia física'),
                    criarItem('2.2.b', 'Decreto que regulamenta a Lei que institui o S.I.M. – cópia física'),
                    criarItem('2.2.c.1', 'Portarias do S.I.M. – cópia física'),
                    criarItem('2.2.c.2', 'Decreto ou documento de indicação de Coordenador – cópia física'),
                    criarItem('2.2.c.3', 'Manual do S.I.M. – cópia física'),
                    criarItem('2.2.c.4', 'POPs – cópia física'),
                    criarItem('2.2.c.5', 'Organograma do órgão'),
                ],
            },
            {
                id: '3',
                titulo: 'Parte 3 - Infraestrutura Administrativa',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('3.1.a', 'Quadro de pessoal'),
                    criarItem('3.1.b', 'Capacitação da equipe'),
                    criarItem('3.1.c', 'Número compatível com as atividades a serem desenvolvidas'),
                    criarItem('3.1.d', 'Lotação no Serviço de Inspeção'),
                    criarItem('3.1.e', 'Escala de trabalho da equipe'),
                    criarItem('3.2.a', 'Material de apoio, mobiliários e equipamentos para suporte administrativo das atividades de inspeção'),
                    criarItem('3.3.a', 'Banco de dados com relação dos estabelecimentos'),
                    criarItem('3.3.b', 'Banco de dados de projetos aprovados'),
                    criarItem('3.3.c', 'Banco de dados de rótulos aprovados'),
                    criarItem('3.3.d', 'Dados nosográficos e de produção'),
                    criarItem('3.3.e', 'Cadastro de produtos no e-SISBI atualizado'),
                    criarItem('3.3.f', 'Cadastro no SG-SIM atualizado'),
                    criarItem('3.4.a', 'Veículos oficiais em número e condições adequadas'),
                    criarItem('3.4.b', 'Laboratório próprio ou terceirizado'),
                ],
            },
            {
                id: '4',
                titulo: 'Parte 4 - Programa de Trabalho de Inspeção e Fiscalização',
                aberta: true,
                observacoes: '',
                camposExtras: {
                    carne: 0,
                    leite: 0,
                    mel: 0,
                    ovos: 0,
                    pescados: 0,
                },
                itens: [
                    criarItem('4.2.a', 'Cumprimento dos POPs'),
                    criarItem('4.2.b', 'Frequência das inspeções de rotina'),
                    criarItem('4.2.c', 'Inspeção permanente nos abates'),
                    criarItem('4.2.d', 'Registro de supervisões'),
                    criarItem('4.2.e', 'Cronograma de análises laboratoriais oficiais'),
                    criarItem('4.2.f', 'Ações de combate à clandestinidade'),
                    criarItem('4.2.g', 'Atividades de educação sanitária'),
                    criarItem('4.3.a', 'Registros de análise e aprovação de projetos de registro e reformas'),
                    criarItem('4.3.b', 'Controle de cancelamento do registro de estabelecimentos'),
                    criarItem('4.3.c', 'Registro da execução das inspeções'),
                    criarItem('4.3.d', 'Registro da execução das supervisões (laudo anual)'),
                    criarItem('4.3.e', 'Registro do atendimento do cronograma de análises laboratoriais'),
                    criarItem('4.3.f', 'Controle de GTA'),
                    criarItem('4.3.g', 'Controle de Autos de Infração e históricos de penalidades'),
                    criarItem('4.3.h', 'Registro das reuniões técnicas realizadas'),
                    criarItem('4.3.i', 'Controle de Processos Administrativos'),
                ],
            },
            {
                id: '5',
                titulo: 'Parte 5 - Inocuidade dos Produtos de Origem Animal',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('5.a', 'Execução da inspeção ante e post mortem, critérios de julgamento e destinação de carcaças'),
                    criarItem('5.b', 'Verificações oficiais dos programas de autocontrole'),
                    criarItem('5.c', 'Avaliação dos resultados das análises laboratoriais'),
                    criarItem('5.d', 'Registro das providências adotadas em relação a resultados fora do padrão'),
                    criarItem('5.e', 'Rastreabilidade'),
                ],
            },
            {
                id: '6',
                titulo: 'Parte 6 - Qualidade dos Produtos de Origem Animal',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('6.a', 'Atendimento aos RTIQ'),
                    criarItem('6.b', 'Embasamento científico e parecer do MAPA para produtos sem RTIQ'),
                    criarItem('6.c', 'Atendimento aos requisitos para aprovação de rotulagem e processos produtivos'),
                    criarItem('6.d', 'Registros pertinentes à análise e aprovação de produtos, formulações e croquis dos rótulos'),
                    criarItem('6.e', 'Controle do uso da logomarca do SISBI'),
                ],
            },
            {
                id: '7',
                titulo: 'Parte 7 - Prevenção e Combate à Fraude',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('7.a', 'Controles relativos à qualidade e composição dos produtos com vistas à prevenção de fraudes'),
                ],
            },
            {
                id: '8',
                titulo: 'Parte 8 - Ações de Controle Ambiental',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('8.a', 'Regularidade ambiental dos estabelecimentos'),
                    criarItem('8.b', 'Autorização para construção, instalação e operação'),
                ],
            },
            {
                id: '9',
                titulo: 'Parte 9 - Atendimento a Solicitações Anteriores',
                aberta: true,
                observacoes: '',
                itens: [
                    criarItem('9.a', 'Atendimento das solicitações anteriores / pendências apontadas'),
                ],
            },
        ]);

        const totaisParte1 = computed(() => {
            return form.equipe.carteiraSaude ? `1 item avaliado` : `0 item avaliado`;
        });

        const contarStatus = (secao, status) => {
            return secao.itens.filter((item) => item.status === status).length;
        };

        const resumo = computed(() => {
            const todosItens = secoes.flatMap((secao) => secao.itens);
            const totalItens = todosItens.length;
            const totalC = todosItens.filter((item) => item.status === 'C').length;
            const totalNC = todosItens.filter((item) => item.status === 'NC').length;
            const totalNA = todosItens.filter((item) => item.status === 'NA').length;
            const totalAplicaveis = totalItens - totalNA;
            const percentualAtendimento =
                totalAplicaveis > 0
                    ? ((totalC / totalAplicaveis) * 100).toFixed(2)
                    : '0.00';

            return {
                totalItens,
                totalC,
                totalNC,
                totalNA,
                totalAplicaveis,
                percentualAtendimento,
            };
        });

        const payloadRelatorio = computed(() => {
            return JSON.stringify(
                {
                    cabecalho: form,
                    secoes,
                    resumo: resumo.value,
                },
                null,
                2
            );
        });

        function adicionarAuditor() {
            form.finalizacao.auditores.push({ nome: '', cargo: '' });
        }

        function removerAuditor(index) {
            form.finalizacao.auditores.splice(index, 1);
        }

        function adicionarPresente() {
            form.finalizacao.presentes.push({ nome: '', cargo: '' });
        }

        function removerPresente(index) {
            form.finalizacao.presentes.splice(index, 1);
        }

        function expandirTodos() {
            secoes.forEach((secao) => {
                secao.aberta = true;
            });
        }

        function recolherTodos() {
            secoes.forEach((secao) => {
                secao.aberta = false;
            });
        }

        function finalizarRelatorio() {
            alert(
                `Relatório pronto para integração.\n` +
                `Conformes: ${resumo.value.totalC}\n` +
                `Não conformes: ${resumo.value.totalNC}\n` +
                `% Atendimento: ${resumo.value.percentualAtendimento}%`
            );
        }

        return {
            form,
            secoes,
            totaisParte1,
            resumo,
            payloadRelatorio,
            contarStatus,
            adicionarAuditor,
            removerAuditor,
            adicionarPresente,
            removerPresente,
            expandirTodos,
            recolherTodos,
            finalizarRelatorio,
        };
    },
};
</script>

<style scoped>
.form-edit-page {
    padding: 20px;
    background: #f4f6f8;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header h1 {
    margin: 0 0 4px 0;
    font-size: 28px;
}

.page-header p {
    margin: 0;
    color: #667085;
}

.header-actions,
.inline-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.card-section {
    background: #fff;
    border: 1px solid #dfe6ec;
    border-radius: 12px;
    padding: 18px;
    margin-bottom: 18px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-title {
    font-size: 18px;
    font-weight: 700;
    color: #12344d;
    margin-bottom: 14px;
}

.subsection-title {
    margin: 20px 0 12px;
    font-size: 15px;
    font-weight: 700;
    color: #1d4f68;
    padding-bottom: 6px;
    border-bottom: 1px solid #e7edf2;
}

.section-header-clickable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin-bottom: 12px;
}

.section-subtitle {
    font-size: 13px;
    color: #667085;
}

.section-toggle {
    font-size: 28px;
    line-height: 1;
    color: #1d4f68;
    width: 28px;
    text-align: center;
}

.form-grid {
    display: grid;
    gap: 14px;
}

.cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
}

.col-span-2 {
    grid-column: span 2;
}

.form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-item label {
    font-size: 13px;
    font-weight: 600;
    color: #344054;
}

.form-item input,
.form-item select,
.form-item textarea {
    width: 100%;
    border: 1px solid #cfd8e3;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    background: #fff;
    box-sizing: border-box;
}

.form-item textarea {
    resize: vertical;
}

.checklist-table {
    border: 1px solid #d8e0e8;
    border-radius: 10px;
    overflow: hidden;
}

.checklist-head,
.checklist-row {
    display: grid;
    grid-template-columns: 1fr 70px 70px 70px;
    align-items: stretch;
}

.checklist-head {
    background: #1d5c74;
    color: #fff;
    font-weight: 700;
}

.checklist-head > div,
.checklist-row > div {
    padding: 12px;
    border-right: 1px solid #d8e0e8;
    display: flex;
    align-items: center;
}

.checklist-head > div:last-child,
.checklist-row > div:last-child {
    border-right: none;
}

.checklist-row {
    border-top: 1px solid #e5ebf0;
    background: #fff;
}

.checklist-row:nth-child(even) {
    background: #fafcfe;
}

.item-desc {
    gap: 10px;
}

.item-code {
    min-width: 62px;
    font-weight: 700;
    color: #1d4f68;
}

.status-col {
    justify-content: center;
    text-align: center;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 18px;
}

.summary-card {
    border: 1px solid #dfe6ec;
    border-radius: 10px;
    padding: 14px;
    background: #fafcfe;
}

.summary-card.destaque {
    background: #eaf7f6;
    border-color: #b7dfd7;
}

.summary-label {
    font-size: 12px;
    color: #667085;
    margin-bottom: 4px;
}

.summary-value {
    font-size: 24px;
    font-weight: 700;
    color: #12344d;
}

.table-simple {
    border: 1px solid #d8e0e8;
    border-radius: 10px;
    overflow: hidden;
}

.table-head,
.table-row {
    display: grid;
    grid-template-columns: 1fr 1fr 80px;
    gap: 0;
}

.table-head {
    background: #eef4f8;
    font-weight: 700;
}

.table-head > div,
.table-row > div {
    padding: 10px;
    border-right: 1px solid #d8e0e8;
    border-top: 1px solid #d8e0e8;
}

.table-head > div:first-child,
.table-head > div:nth-child(2),
.table-head > div:nth-child(3) {
    border-top: none;
}

.table-head > div:last-child,
.table-row > div:last-child {
    border-right: none;
}

.col-acoes {
    text-align: center;
    justify-content: center;
    align-items: center;
}

.btn {
    border: none;
    border-radius: 8px;
    padding: 10px 14px;
    cursor: pointer;
    font-weight: 600;
}

.btn-primary {
    background: #1d5c74;
    color: #fff;
}

.btn-light {
    background: #edf2f7;
    color: #12344d;
}

.btn-icon {
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 18px;
}

.mt-12 {
    margin-top: 12px;
}

.json-preview {
    background: #0f172a;
    color: #e2e8f0;
    padding: 14px;
    border-radius: 10px;
    font-size: 12px;
    overflow: auto;
}

@media (max-width: 1100px) {
    .cols-3,
    .cols-4,
    .cols-5,
    .summary-grid {
        grid-template-columns: 1fr 1fr;
    }

    .col-span-2 {
        grid-column: span 1;
    }
}

@media (max-width: 768px) {
    .page-header {
        flex-direction: column;
    }

    .cols-3,
    .cols-4,
    .cols-5,
    .summary-grid {
        grid-template-columns: 1fr;
    }

    .checklist-head,
    .checklist-row,
    .table-head,
    .table-row {
        grid-template-columns: 1fr;
    }

    .status-col {
        justify-content: flex-start;
    }
}
</style>